export const useCast = () => {
    return {
        deviceName: undefined,
        cast: () => {},
        loadMedia: () => {},
        setWasCastSessionEnded: () => {},
        wasCastSessionEnded: false,
        isCastConnected: false,
    };
};
